// extracted by mini-css-extract-plugin
export default {"textField":"DemoRequestModal_textField__xFxP2","demoModal":"DemoRequestModal_demoModal__BZico"};